import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PurchaseService } from '@shared/services/purchase.service';
import { SpinnerOverlayService } from '@shared/services/spinner-overlay.service';
import { ActionName } from '@shared/models/effects-names.model';
import {
  GetDocumentImageStatus,
  OPEN_PURCHASE_MODAL,
  OpenPurchaseModal,
  PURCHASE_DOCUMENT_IMG,
  PURCHASE_REPORT,
  PurchaseDocumentImg,
  PurchaseReport,
  SetPurchaseErrorMessage,
  SetReportsAsNotLoaded
} from '@store/reports/reports.actions';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class PurchaseEffect {

  constructor(private readonly actions$: Actions,
              private readonly purchaseService: PurchaseService,
              private readonly spinnerOverlayService: SpinnerOverlayService) {
  }

  openPurchaseModal$: Observable<void> = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(OPEN_PURCHASE_MODAL),
        map((action: OpenPurchaseModal) => this.purchaseService.openPurchaseDialog(action.payload))
      );
  }, {dispatch: false});

  purchaseReport$: Observable<SetReportsAsNotLoaded | SetPurchaseErrorMessage> = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(PURCHASE_REPORT),
        this.spinnerOverlayService.wrapRequest((data: PurchaseReport) =>
          this.purchaseService.authorizeCreditCard(data.payload).pipe(
            map((resp: { transactionId: string }) => {
              this.purchaseService.closeDialog();
              return new SetReportsAsNotLoaded(resp && resp.transactionId || '');
            }),
            catchError((response: HttpErrorResponse) => {
              // tslint:disable:no-magic-numbers
              const purchaseErrorMessage = response.status === 400
                ? response.error.error : 'Service Unavailable, Please try again later.';
              return of(new SetPurchaseErrorMessage(purchaseErrorMessage));
            })
          ), ActionName.PURCHASE_REPORT)
      );
  });

  buyDocumentImg$: Observable<GetDocumentImageStatus> = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(PURCHASE_DOCUMENT_IMG),
        this.spinnerOverlayService.wrapRequest((action: PurchaseDocumentImg) => {
          return this.purchaseService.authorizeCreditCard(action.payload)
            .pipe(
              map((resp: { transactionId: string }) => {
                this.purchaseService.closeDialog();
                return new GetDocumentImageStatus(action.payload.resourceUrl + `&transactionId=${resp.transactionId}`);
              })
            );
        }, ActionName.LOAD_IMAGES_ON_PICTURE_VIEWER)
      );
  });
}
